




















































import {
  defineComponent, PropType, computed, toRefs,
} from '@nuxtjs/composition-api';
import { SfAccordion } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { getProductIncluded } from '~/modules/catalog/product/getters/productGetters';
import SvgImage from '~/components/General/SvgImage.vue';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  components: {
    SfAccordion,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    tab: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { lastOpenedTabId, resetLastOpenedTabId } = toRefs(useProductStore());

    const items = computed(() => getProductIncluded(props.product).split(';').filter(Boolean).map((i) => i.trim()));

    return {
      lastOpenedTabId,
      resetLastOpenedTabId,
      items,
      getProductIncluded,
    };
  },
});
